import { render, staticRenderFns } from "./AdCode.vue?vue&type=template&id=1b8d01d9&scoped=true"
import script from "./AdCode.vue?vue&type=script&lang=js"
export * from "./AdCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8d01d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b8d01d9')) {
      api.createRecord('1b8d01d9', component.options)
    } else {
      api.reload('1b8d01d9', component.options)
    }
    module.hot.accept("./AdCode.vue?vue&type=template&id=1b8d01d9&scoped=true", function () {
      api.rerender('1b8d01d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/ads/advList/components/AdCode.vue"
export default component.exports